import { useDispatch } from "react-redux";
import { showToast } from "../components";
import { ENDPOINTS } from "../redux/apiConfig";
import axiosRequest from "../redux/slices/universal/axiosService";
import { updateTotalUnreadCount } from "../redux/slices/wf-notifications/notificationSlice";
import store from "../redux/store";

export const fetchNotifications = async ({
  limit = 10,
  page = 1,
  filters = {},
  ...rest
}) => {
  try {
    const payload = {
      coll: "Notification",
      lim: limit,
      pg: page,
      ret: "title message isRead meta eventType addedOn",
      fil: JSON.stringify({
        ...filters,
      }),
      ...rest,
    };
    const notifications = await axiosRequest({
      method: "GET",
      url: ENDPOINTS.WF_NOTIFICATIONS.GET_ALL,
      params: payload,
    });
    const notificationData = notifications?.data?.data || [];
    return {
      notifications: notificationData,
    };
  } catch (error) {
    console.error("Error in fetchNotifications:", error);
  }
};
export const fetchTotalCounts = async ({ categories = [] ,filters={}}) => {
  const requests = categories.map((cat) =>
    axiosRequest({
      method: "GET",
      url: ENDPOINTS.WF_NOTIFICATIONS.GET_TOTAL_COUNT,
      params: {
        coll: "Notification",
        fil: JSON.stringify({
          "meta.entity": { type: "NONE", value: cat.db },
          ...(cat.extrafilters && {...cat.extrafilters}),
          ...filters
        }),
      },
    }).then((res) => ({
      category: cat.name,
      count: res?.data?.data || 0,
    }))
  );

  const results = await Promise.allSettled(requests);

  return results.map((r) =>
    r.status === "fulfilled" ? r.value : { category: null, data: 0 }
  );
};

export const updateTotalCountToStore = async ({userId}) => {
  const dispatch = store.dispatch;
  try {
    const res = await axiosRequest({
      method: "GET",
      url: ENDPOINTS.WF_NOTIFICATIONS.GET_TOTAL_COUNT,
      params: {
        coll: "Notification",
        fil: JSON.stringify({
          "userId": { type: "NONE", value: userId },
          "isRead.status": { type: "NONE", value: false },
        }),
      }
    });
    dispatch(updateTotalUnreadCount({count:res?.data?.data || 0}));
  } catch (error) {
    console.error("Error in updateTotalCountToStore:", error);
  }
};

export const updateNotification = async ({ filter = {}, payload  }) => {
  try {
    await axiosRequest({
      method: "PATCH",
      url: ENDPOINTS.WF_NOTIFICATIONS.UPDATE,
      params: {
        coll: "Notification",
        fil: JSON.stringify(filter),
      },
      data: { payload },
    });
  } catch (error) {
    console.error("Error in updateNotification:", error);
  }
};
